import React from 'react';
import { Panier } from '../../components/organisms/Panier';

const PanierView = () => {
  return <Panier />;
};
export default PanierView;
